/* eslint-disable */
export default {
  meetingTitle: '{extensionName}:n tapaaminen',
} as const;

// @key: @#@"meetingTitle"@#@ @source: @#@"{extensionName}'s Meeting"@#@
